import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus } from "lucide-react";
import { Reveal, Eyebrow, EASE } from "./Reveal";
import { WhatsAppIcon } from "./icons";
import { WHATSAPP_URL } from "./config";

const FAQS = [
  {
    q: "¿Hacen envíos a domicilio en Guayaquil o provincias?",
    a: "Sí, coordinamos envíos en Guayaquil y despachos a nivel nacional a través de WhatsApp.",
    testid: "faq-accordion-item-0",
  },
  {
    q: "¿Manejan ventas al por mayor o para emprendimientos?",
    a: "Ofrecemos atención especializada para reposteros, pastelerías y emprendedores con precios competitivos.",
    testid: "faq-accordion-item-1",
  },
  {
    q: "¿Cómo puedo consultar la disponibilidad de un producto?",
    a: "Haz clic en nuestro botón de WhatsApp, envíanos la foto o nombre del producto y te confirmamos de inmediato.",
    testid: "faq-accordion-item-2",
  },
];

export default function Faq() {
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" className="py-14 sm:py-18 lg:py-20">
      <div className="mx-auto grid max-w-7xl gap-10 px-4 sm:px-8 lg:grid-cols-[1fr_1.35fr] lg:gap-16 lg:px-12">
        <div className="lg:sticky lg:top-32 lg:self-start">
          <Reveal>
            <Eyebrow>Resolvemos tus dudas</Eyebrow>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-5 font-display text-3xl font-semibold leading-tight tracking-tight text-choco sm:text-4xl lg:text-5xl">
              Preguntas frecuentes
            </h2>
          </Reveal>
          <Reveal delay={0.18}>
            <p className="mt-4 max-w-md text-base leading-relaxed text-cocoa sm:text-lg">
              Todo lo que necesitas saber antes de tu primer pedido. Y si te
              queda una duda, escríbenos: respondemos en minutos.
            </p>
          </Reveal>
          <Reveal delay={0.25}>
            <a
              data-testid="faq-whatsapp-cta"
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-7 inline-flex items-center gap-3 rounded-full bg-choco px-7 py-3.5 font-bold text-cream transition duration-300 hover:-translate-y-1 hover:bg-rose"
            >
              <WhatsAppIcon className="h-5 w-5" />
              ¿Otra duda? Escríbenos
            </a>
          </Reveal>
        </div>

        <div className="space-y-3.5">
          {FAQS.map((f, i) => {
            const isOpen = open === i;
            return (
              <Reveal key={f.testid} delay={i * 0.1}>
                <div
                  data-testid={f.testid}
                  className={`overflow-hidden rounded-3xl border transition duration-300 ${
                    isOpen
                      ? "border-rose/40 bg-white shadow-[0_25px_50px_-30px_rgba(217,72,104,0.35)]"
                      : "border-linebr bg-white hover:border-rose/25"
                  }`}
                >
                  <button
                    data-testid={`${f.testid}-trigger`}
                    onClick={() => setOpen(isOpen ? -1 : i)}
                    className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left sm:px-7"
                    aria-expanded={isOpen}
                  >
                    <span className="font-display text-lg font-semibold text-choco sm:text-xl">
                      {f.q}
                    </span>
                    <motion.span
                      animate={{ rotate: isOpen ? 45 : 0 }}
                      transition={{ duration: 0.3, ease: EASE }}
                      className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-full transition duration-300 ${
                        isOpen ? "bg-rose text-cream" : "bg-cream2 text-choco"
                      }`}
                    >
                      <Plus className="h-4 w-4" />
                    </motion.span>
                  </button>
                  <AnimatePresence initial={false}>
                    {isOpen && (
                      <motion.div
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: "auto", opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.35, ease: EASE }}
                      >
                        <p className="px-6 pb-6 text-[15px] leading-relaxed text-cocoa sm:px-7 sm:text-base">
                          {f.a}
                        </p>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
